import type React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { useShiftAuth } from '../contexts/ShiftAuthProvider';
import { LoginPage } from '../pages/LoginPage';
import { ProtectedLayout } from '../layouts/ProtectedLayout';

export const ShiftRouter: React.FC = () => {
  const { isAuthenticated } = useShiftAuth();
  const defaultRoute = isAuthenticated ? '/' : '/login';

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/*" element={<ProtectedLayout />} />
        <Route path="*" element={<Navigate to={defaultRoute} replace />} />
      </Routes>
    </BrowserRouter>
  );
};
